module.exports = __webpack_public_path__ + "img/1.440fa513.png";